import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

/* ================= THUNKS ================= */


// CREATE JOB
export const createJob = createAsyncThunk(
    "jobs/createJob",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await api.post("/create-jobpost", payload);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// GET ALL JOBS
export const getAllJobs = createAsyncThunk(
    "jobs/getAllJobs",
    async ({ page = 1 }, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/all-jobs?page=${page}`);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// GET JOBS BY USER
export const getJobsByUser = createAsyncThunk(
    "jobs/getJobsByUser",
    async (userId, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/user-jobs/${userId}`);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// UPDATE JOB
export const updateJob = createAsyncThunk(
    "jobs/updateJob",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const { data } = await api.put(`/update-job/${id}`, payload);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// DELETE JOB
export const deleteJob = createAsyncThunk(
    "jobs/deleteJob",
    async (id, { rejectWithValue }) => {
        try {
            await api.delete(`/delete-job/${id}`);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// APPLY JOB
export const applyJob = createAsyncThunk(
    "jobs/applyJob",
    async (payload, { rejectWithValue }) => {
        try {

            console.log("payload", payload);

            const { data } = await api.post("/apply-job", payload);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// GET APPLICANTS
export const getApplicantsByJob = createAsyncThunk(
    "jobs/getApplicantsByJob",
    async (jobId, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/job/${jobId}`);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// GET APPLIED JOBS (SERVICEMEN)
export const getAppliedJobsByServicemen = createAsyncThunk(
    "jobs/getAppliedJobsByServicemen",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await api.get("/servicemen/applied-jobs");
            return data.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || err.message
            );
        }
    }
);



/* ================= SLICE ================= */

const jobSlice = createSlice({
    name: "jobs",
    initialState: {
        jobs: [],
        myJobs: [],
        applicants: [],
        appliedJobs: [],
        loading: false,
        error: null,
        page: 1,
        totalPages: 1,
    },
    reducers: {
        clearJobError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(createJob.pending, (state) => {
                state.loading = true;
            })
            .addCase(createJob.fulfilled, (state, action) => {
                state.loading = false;
                state.jobs.unshift(action.payload);
            })
            .addCase(createJob.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(getAllJobs.fulfilled, (state, action) => {
                state.jobs = action.payload.data;
                state.page = action.payload.page;
                state.totalPages = action.payload.totalPages;
            })

            .addCase(getJobsByUser.fulfilled, (state, action) => {
                state.myJobs = action.payload;
            })

            .addCase(updateJob.fulfilled, (state, action) => {
                state.jobs = state.jobs.map((j) =>
                    j._id === action.payload._id ? action.payload : j
                );
            })

            .addCase(deleteJob.fulfilled, (state, action) => {
                state.jobs = state.jobs.filter(j => j._id !== action.payload);
                state.myJobs = state.myJobs.filter(j => j._id !== action.payload);
            })


            .addCase(getApplicantsByJob.fulfilled, (state, action) => {
                state.applicants = action.payload;
            })

            .addCase(getAppliedJobsByServicemen.pending, (state) => {
                state.loading = true;
            })

            .addCase(getAppliedJobsByServicemen.fulfilled, (state, action) => {
                state.loading = false;
                state.appliedJobs = action.payload;
            })

            .addCase(getAppliedJobsByServicemen.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


    },
});

export const { clearJobError } = jobSlice.actions;
export default jobSlice.reducer;
